export function getSiteUrl() {
  return (process.env.REACT_APP_SITE_URL || "https://grunpflege.de").replace(
    /\/+$/,
    "",
  );
}

export function absoluteUrl(pathOrUrl) {
  if (pathOrUrl == null) return "";
  const s = String(pathOrUrl).trim();
  if (!s) return "";
  if (/^https?:\/\//i.test(s)) return s;
  const path = s.startsWith("/") ? s : `/${s}`;
  return `${getSiteUrl()}${path}`;
}

export function defaultOgImageAbsoluteUrl() {
  const pub = (process.env.PUBLIC_URL || "").replace(/\/+$/, "");
  return `${getSiteUrl()}${pub}/og-image.png`;
}
